const control = "_control_sqdq4_10";
const styles = {
  control,
  "enable-ligatures": "_enable-ligatures_sqdq4_62"
};
export {
  control,
  styles as default
};
//# sourceMappingURL=Text.module.css.js.map
